import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from 'theme'

const displaysToolbarStyles: IStyles = {
    modalContainer: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: 'rgba(0,0,0,0.7)',
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: colors.white,
        padding: 30,
        borderRadius: 20,
        width: 500,

        [mediaCSS.tabMini]: {
            width: '96%',
        },
    },
    caption: {
        textAlign: 'center',
        fontSize: 18,
    },
    description: {
        marginTop: 8,
        marginBottom: 20,
        textAlign: 'center',
        color: colors.grey,

        span: {
            color: colors.blackLight,
        },
    },
    tip: {
        marginTop: 8,
        color: colors.grey,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
    button: {
        minWidth: 140,
        display: 'flex',
        justifyContent: 'center',
        margin: '0 6px',
    },
}

addStyles(displaysToolbarStyles)
export default displaysToolbarStyles
